import styled from "styled-components";

export default function CustomerCard({ title, children, full = false }) {
  return (
    <Card $full={full}>
      {title && <h2>{title}</h2>}
      {children}
    </Card>
  );
}

const Card = styled.article`
  grid-column: ${({ $full }) => ($full ? "1 / -1" : "auto")};
  padding: 1.2rem;
  border-radius: 22px;
  background: #1d263d;
  border: 1px solid rgba(255, 255, 255, 0.08);

  h2 {
    margin: 0 0 1rem;
    font-size: 1.1rem;
    font-weight: 950;
  }
`;
